<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                        ref="name"
                        label="角色名称"
                        prop="name"
                        :help="formErr.name"
                        :validateStatus='!formErr.name||formErr.name==""?"":"error"'
                >
                    <a-input
                            :maxLength=50
                            v-model="form.name"
                            @change="(e) => { formErr.name=''}"
                            @blur="(e) => {  form.name = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="remark"
                        label="备注"
                        prop="remark"
                        :help="formErr.remark"
                        :validateStatus='!formErr.remark||formErr.remark==""?"":"error"'
                >
                    <a-textarea :maxLength=200 :rows="4" v-model="form.remark"
                                @change="(e) => { formErr.remark=''}"
                                @blur="(e) => {  form.remark = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item
                        ref="status"
                        label="状态"
                        prop="status"
                        :extra="formErr.status"
                        :validateStatus='!formErr.status||formErr.status==""?"":"error"'
                >
                    <a-radio-group v-model="form.status">
                        <a-radio :value="1"> 启用</a-radio>
                        <a-radio :value="0"> 停用</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button  @click="onClose" >
                取消
            </a-button>

            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm, drawerConfig, validator} from "../../../utils/utils"
    import API from "../api";

    export default {
        name: "roleForm",
        props: ["visible", "title", "editId"],
        data() {
            return {
                drawerConfig,
                form: {
                    status: 1,
                    remark: "",
                    name: ""
                },
                formErr: {
                    name: "",
                    status: "",
                    remark: ""
                },
                rules: {
                    name: [{required: true, message: "请输入角色名称", trigger: "blur"}, { whitespace: true,  message: "请输入角色名称" }, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.name)
                        }, trigger: "blur"
                    },],
                },
                layout: {
                    labelCol: {span: 4},
                    wrapperCol: {span: 14},
                },
            };
        },
        watch: {
            editId: function (a, b) {
                if (a != "") {
                    API.administrator.EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr = {name: "", status: "", remark: ""}
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD : url = API.administrator.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
